import { SearchInspector } from './search-inspector';

export default SearchInspector;
